<template>
  <div class="videoMaterial">
    <el-card>
      <div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="16" :lg="16">
            <span>选择视频</span>
            <el-button style="margin-left: 20px" type="primary" plain @click="
                ;(selectVideoVisibleBlock = true), (selectVideoVisible = true)
              ">选择视频</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12">
            <div style="padding-left: 70px">
              <el-table ref="multipleTable" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" :data="videoList" tooltip-effect="dark" style="margin-top: 20px" border>
                <el-table-column prop="name" label="视频" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <div style="display: flex; justify-content: space-between">
                      <el-input v-if="scope.row.editBlock" size="small" v-model="scope.row.name" style="width: 200px">
                        <span class="operation-style" style="line-height: 35px" slot="suffix" @click="updateVideoInfoByAttachmentList(scope.row)">保存</span>
                        <span style="line-height: 35px; margin-left: 10px" slot="suffix" @click="editBlockCancel(scope.row)">取消</span>
                      </el-input>
                      <div v-else>{{ scope.row.name }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="size" label="大小" width="120">
                  <template slot-scope="scope">{{ (scope.row.size / 1024 / 1024).toFixed(4) }}MB</template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12" style="margin-top: 20px">
            <el-form :model="editForm" label-width="70px">
              <el-form-item label="视频名称" prop="name">
                <el-input v-model="editForm.name" size="small" placeholder="请输入名称" auto-complete="off" maxlength="30" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="播放次数" prop="playCount">
                <el-input style="width: 120px" v-model="editForm.showPlayCount" size="small" placeholder="请输入播放次数" auto-complete="off" maxlength="11" type="number"></el-input>
                <span style="margin-left: 10px">实际播放：{{
                    editForm.playCount == null ? 0 : editForm.playCount
                  }}</span>
              </el-form-item>
              <el-form-item label="试看" prop="tryUse">
                <el-checkbox v-model="editForm.tryUse">开启片段试看</el-checkbox>
                <span>视频前<el-input size="small" :disabled="!editForm.tryUse" style="width: 80px; margin: auto 5px" v-model="editForm.tryDuration" type="number"></el-input>分钟为试看范围</span>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="12">
            <div style="margin-top: 20px; margin-left: 70px">
              <el-button @click="$router.go(-1)">返 回</el-button>
              <el-button type="primary" @click="updateTencentVideoId">提 交</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <el-dialog title="选择视频" :visible.sync="selectVideoVisible" width="800px" left>
        <videoMaterial @videoListChange="changeVideoList" v-if="selectVideoVisibleBlock"></videoMaterial>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import videoMaterial from "../common/videoMaterial";
export default {
  components: { videoMaterial },
  data () {
    return {
      loading: false,
      videoListBlock: false,
      selectVideoVisible: false,
      selectVideoVisibleBlock: false,
      videoList: [],
      editForm: {},
    };
  },
  computed: {},
  methods: {
    getVideoInfo () {
      this.api.videoInfo
        .getVideoInfo({ id: this.$route.query.id })
        .then((result) => {
          this.videoList.push(result.data);
          this.editForm = result.data;
          if (this.editForm.tryUse == 1) {
            this.editForm.tryUse = true;
          }
        }).catch((error) => {
          console.log(error);
        });
    },
    updateTencentVideoId () {
      if (this.bindTencentBlock) {
        return;
      }
      this.bindTencentBlock = true;
      let obj = {
        videoInfo: this.editForm,
      }
      if (obj.videoInfo.tryUse) {
        obj.videoInfo.tryUse = 1;
      } else {
        obj.videoInfo.tryUse = -1;
      }
      if (this.videoListBlock) {
        obj.id = this.videoList[0].id,
          obj.objectId = this.videoList[0].objectId
      }
      this.api.videoInfo.updateTencentVideoId(obj).then((result) => {
        if (result.success) {
          this.bindTencentBlock = false;
          // this.$router.push({ path: "/videoCours" });
          this.$router.go(-1);
        }
      });
    },
    updateVideoInfoByAttachmentList (row) {
      this.api.videoInfo.updateVideoInfo(row).then((result) => {
        if (result.success) {
          this.$set(row, "editBlock", false);
        }
      });
    },
    editBlockClick (row) {
      this.$set(row, "editBlock", true);
    },
    editBlockCancel (row) {
      this.$set(row, "editBlock", false);
    },
    deleteVideo (row) {
      this.$confirm("将会删除该视频，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.videoList.forEach((e, index) => {
          if (e.id == row.id) {
            this.videoList.splice(index, 1);
          }
        });
      });
    },
    changeVideoList (ids) {
      if (ids.length > 1) {
        this.$message.error("最多选择一个视频进行替换!")
        return;
      }
      this.videoList = ids;
      this.videoList.forEach((e) => {
        this.$set(e, "editBlock", false);
      });
      this.videoListBlock = true;
      this.selectVideoVisible = false;
      this.selectVideoVisibleBlock = false;
    },
  },
  mounted () {
    this.getVideoInfo();
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/videoCourse/editVideo.vue